module.exports = __webpack_public_path__ + "static/media/success.7a3d40a3.svg";